import { connect } from 'react-redux';
import { getExpenses, getExpenseById, onSubmit, resetPage, resetMeta, exportExpenses, resetHasDownload, resetSelectedExpense, deleteExpense } from '../../actions/ExpensePage';
import { getActiveSubscription } from '../../actions/BillingPage';
import { getEnumData } from '../../actions/EnumData';
import ExpensePage from './ExpensePage';

const mapsStateToProps = state => ({
	expensePageProps: state.expensePageReducer,
	enumData: state.enumDataReducer
});

const mapsDispatchToProps = dispatch => ({
	getActiveSubscription() {
		dispatch(getActiveSubscription());
	},
	getExpenses(options) {
		dispatch(getExpenses(options));
	},
	getEnumData() {
		dispatch(getEnumData());
	},
	exportExpenses(options) {
		dispatch(exportExpenses(options));
	},
	getExpenseById(options) {
		dispatch(getExpenseById(options));
	},
	onSubmit(options) {
		dispatch(onSubmit(options));
	},
	resetSelectedExpense() {
		dispatch(resetSelectedExpense());
	},
	deleteExpense(id) {
		dispatch(deleteExpense(id));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetHasDownload() {
		dispatch(resetHasDownload());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(ExpensePage);
